import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PoliticaDeCookies.css';

const PoliticaDeCookies: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="cookies-page">
      <header className="cookies-header">
        <div className="cookies-header-content">
          <div className="cookies-logo" onClick={() => navigate('/')}>
            <img src="/logo_transp.png" alt="ContratoSeguro" />
          </div>
          <button onClick={() => navigate('/')} className="btn-back">
            Voltar para o inicio
          </button>
        </div>
      </header>

      <main className="cookies-main">
        <div className="cookies-container">
          <div className="cookies-content">
            <h1>POLITICA DE COOKIES — CONTRATOSEGURO</h1>
            <p className="cookies-updated">Última atualização: 6 de fevereiro de 2026</p>

            <p className="cookies-intro">
              Esta <strong>Politica de Cookies</strong> explica como o <strong>ContratoSeguro</strong>
              utiliza cookies e tecnologias semelhantes para garantir o funcionamento da plataforma,
              melhorar a experiencia do usuario e cumprir as exigencias da{' '}
              <strong>Lei Geral de Protecao de Dados (LGPD)</strong>.
            </p>

            <p className="cookies-intro">
              Ao continuar navegando em nosso site ou utilizar a Plataforma, voce concorda com o uso
              de cookies conforme descrito nesta Politica, podendo gerenciar suas preferencias a
              qualquer momento.
            </p>

            <section className="cookies-section">
              <h2>1. O que sao cookies</h2>
              <p>
                Cookies sao pequenos arquivos de texto armazenados no seu dispositivo quando voce
                acessa um site. Eles servem para reconhecer seu dispositivo, lembrar preferencias e
                melhorar a navegacao.
              </p>
              <p>
                Cookies <strong>nao identificam diretamente</strong> uma pessoa, mas podem conter
                informacoes associadas ao seu uso da plataforma.
              </p>
            </section>

            <section className="cookies-section">
              <h2>2. Por que utilizamos cookies</h2>
              <p>Utilizamos cookies para:</p>
              <ul>
                <li>Garantir o funcionamento correto da plataforma</li>
                <li>Manter voce autenticado durante a navegacao</li>
                <li>Melhorar a seguranca e prevenir fraudes</li>
                <li>Lembrar preferencias do usuario</li>
                <li>Registrar o aceite das politicas e do armazenamento de dados das partes do contrato</li>
                <li>Analisar desempenho e uso do site</li>
                <li>Melhorar continuamente nossos servicos</li>
              </ul>
            </section>

            <section className="cookies-section">
              <h2>3. Tipos de cookies utilizados</h2>
              <h3>3.1. Cookies essenciais (obrigatorios)</h3>
              <p>
                Esses cookies sao necessarios para o funcionamento basico da Plataforma e nao podem
                ser desativados.
              </p>
              <p>Exemplos:</p>
              <ul>
                <li>Autenticacao de login</li>
                <li>Manutencao de sessao</li>
                <li>Seguranca</li>
                <li>Registro do status de consentimento de cookies e de politicas</li>
                <li>Prevencao de acessos nao autorizados</li>
              </ul>
              <p>Sem esses cookies, algumas funcionalidades podem nao funcionar corretamente.</p>

              <h3>3.2. Cookies de desempenho e estatistica</h3>
              <p>
                Esses cookies coletam informacoes de forma agregada e anonima sobre como os usuarios
                utilizam a Plataforma.
              </p>
              <p>Finalidade:</p>
              <ul>
                <li>Medir numero de acessos</li>
                <li>Identificar paginas mais visitadas</li>
                <li>Detectar erros tecnicos</li>
                <li>Melhorar a performance e usabilidade</li>
              </ul>
              <p>Exemplo de ferramentas: Google Analytics ou servicos similares.</p>
              <p>Esses cookies sao utilizados apenas com consentimento do usuario, quando aplicavel.</p>

              <h3>3.3. Cookies de preferencias</h3>
              <p>Permitem lembrar escolhas feitas pelo usuario, como:</p>
              <ul>
                <li>Idioma</li>
                <li>Configuracoes de visualizacao</li>
                <li>Preferencias de privacidade e de politicas aceitas</li>
                <li>Preferencias de navegacao</li>
              </ul>
              <p>Esses cookies tornam a experiencia mais personalizada.</p>

              <h3>3.4. Cookies de terceiros</h3>
              <p>
                Em alguns casos, utilizamos cookies fornecidos por terceiros confiaveis, apenas para:
              </p>
              <ul>
                <li>Autenticacao</li>
                <li>Analise de desempenho</li>
                <li>Seguranca</li>
              </ul>
              <p>
                Nao utilizamos cookies para publicidade comportamental nem para venda de dados.
              </p>
            </section>

            <section className="cookies-section">
              <h2>4. Consentimento para uso de cookies</h2>
              <p>
                Ao acessar a Plataforma pela primeira vez, voce vera um <strong>banner de cookies</strong>,
                onde podera:
              </p>
              <ul>
                <li>Aceitar todos os cookies</li>
                <li>Recusar cookies nao essenciais</li>
                <li>Configurar suas preferencias</li>
              </ul>
              <p>Seu consentimento pode ser alterado a qualquer momento.</p>
              <p>
                Utilizamos cookies essenciais para registrar quando voce ativa a opcao
                <strong> "Concordo com as politicas"</strong>, incluindo o armazenamento de dados
                pessoais das partes do contrato, conforme nossos termos e politicas.
              </p>
            </section>

            <section className="cookies-section">
              <h2>5. Como gerenciar ou desativar cookies</h2>
              <p>Voce pode, a qualquer momento:</p>
              <ul>
                <li>Ajustar suas preferencias pelo banner de cookies</li>
                <li>Configurar seu navegador para bloquear ou excluir cookies</li>
              </ul>
              <p>Links uteis para os principais navegadores:</p>
              <ul>
                <li>Google Chrome</li>
                <li>Mozilla Firefox</li>
                <li>Safari</li>
                <li>Microsoft Edge</li>
              </ul>
              <p>
                <strong>Atencao:</strong> A desativacao de cookies essenciais pode afetar o
                funcionamento da Plataforma.
              </p>
            </section>

            <section className="cookies-section">
              <h2>6. Base legal para o uso de cookies</h2>
              <p>O tratamento de dados por meio de cookies ocorre com base nas seguintes hipoteses:</p>
              <ul>
                <li><strong>Execucao do contrato</strong> (cookies essenciais)</li>
                <li><strong>Consentimento do titular</strong> (cookies nao essenciais)</li>
                <li><strong>Legitimo interesse</strong>, quando aplicavel</li>
              </ul>
            </section>

            <section className="cookies-section">
              <h2>7. Alteracoes desta politica</h2>
              <p>
                Esta Politica de Cookies pode ser atualizada periodicamente para refletir mudancas
                legais ou operacionais.
              </p>
              <p>A versao mais recente estara sempre disponivel na Plataforma.</p>
            </section>

            <section className="cookies-section">
              <h2>8. Contato</h2>
              <p>Para duvidas ou solicitacoes relacionadas a esta Politica de Cookies, entre em contato:</p>
              <p>📧 <strong>privacidade@contratoseguro.com</strong></p>
            </section>

            <div className="cookies-acceptance">
              <p><strong>ContratoSeguro</strong></p>
              <p><em>Transparencia, seguranca e respeito a sua privacidade.</em></p>
            </div>
          </div>
        </div>
      </main>

      <footer className="cookies-footer">
        <div className="cookies-footer-content">
          <p>&copy; 2026 ContratoSeguro. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default PoliticaDeCookies;
